import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagPLSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="mask0_23371_24110" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_23371_24110)">
        <path
          d="M2 2.75C2 2.33579 2.33579 2 2.75 2H13.25C13.6642 2 14 2.33579 14 2.75V13.25C14 13.6642 13.6642 14 13.25 14H2.75C2.33579 14 2 13.6642 2 13.25V2.75Z"
          fill="#DC143C"
        />
        <rect x="2" y="2" width="12" height="6" fill="white" />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
